import React       from 'react';
import PropTypes   from 'prop-types';
import {
  AiOutlineHome,
  AiOutlineUnorderedList,
  AiOutlineSetting,
  AiOutlineUser
} from 'react-icons/ai';
import { FaHeartbeat } from 'react-icons/fa';
import './NavBar.scss';

export default function NavBar({ active, onChange }) {
  return (
    <nav className="bottom-nav">
      <button
        className={`nav-item ${active === 'home' ? 'active' : ''}`}
        onClick={() => onChange('home')}
      >
        <AiOutlineHome />
        <span>Home</span>
      </button>

      <button
        className={`nav-item ${active === 'results' ? 'active' : ''}`}
        onClick={() => onChange('results')}
      >
        <AiOutlineUnorderedList />
        <span>Result</span>
      </button>

      {/* centre floating action button */}
      <button
        className="fab"
        onClick={() => onChange('scan')}
      >
        <FaHeartbeat />
      </button>

      <button
        className={`nav-item ${active === 'settings' ? 'active' : ''}`}
        onClick={() => onChange('settings')}
      >
        <AiOutlineSetting />
        <span>Setting</span>
      </button>

      <button
        className={`nav-item ${active === 'profile' ? 'active' : ''}`}
        onClick={() => onChange('profile')}
      >
        <AiOutlineUser />
        <span>Profile</span>
      </button>
    </nav>
  );
}

NavBar.propTypes = {
  active  : PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
